import SearchIcon from "@mui/icons-material/Search";
import React, {useEffect, useRef} from "react";

interface SearchBarProps {
	setSearchQuery: (search: string) => void;
	searchQuery: string;
}

export const SearchBar: React.FC<SearchBarProps> = ({
	setSearchQuery,
	searchQuery,
}) => {

	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
				e.preventDefault();
				inputRef.current?.focus();
				inputRef.current?.select();
			}
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => {
			window.removeEventListener("keydown", handleKeyDown);
		};
	}, []);

	return (
		/* h-12 matches header bar height, pt-1 matches padding between header bar and inner app layout */
		<div className="flex items-center bg-stone-100 pt-1 absolute top-0 left-0 right-0 z-10">
			<div className="flex items-center h-12">
				<div className="pl-4 flex items-center text-stone-400/80">
					<SearchIcon style={{ fontSize: "18px" }} />
				</div>
				<input
					className="w-full h-7 py-1 pl-2 pr-3 bg-transparent border-0 text-xs text-stone-700 placeholder-stone-400/80 focus:outline-none focus:ring-0"
					placeholder="Suche..."
					aria-label="search"
					value={searchQuery}
					onChange={(e) => setSearchQuery(e.target.value)}
					autoFocus
					ref={inputRef}
				/>
			</div>
		</div>
	);
};
